import simpleFetch from "../../../../../../utils/simpleFetch";

export default {
  checkInvoiceValidity: (invoiceId, callback) => {
    let result = null;
    simpleFetch("GET", `/v1/invoices/${invoiceId}/is-valid`, {}).then(
      (response) => {
        result = response.changed;
        callback(result);
      }
    );
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/InvoiceUtils.js